<template>
  <div>
    <div class="row mt-4">
      <div class="col-sm-12 mb-4">
        <h4>1. District Map</h4>
      </div>
      <div class="col-sm-12">
        <h5 class="font-weight-bold">Configurations</h5>
      </div>
      <div class="col-sm-12">
        <div class="form-group row">
          <div class="col-sm-3">
            <div class="form-check form-check-inline">
              <label class="form-check-label mr-2" for="district-random-color">Random Color</label>
              <input
                class="form-check-input"
                type="checkbox"
                v-model="mapConfig.district_map.random_color"
                @change="toggleRandomColor('district_map')"
                value="true"
                id="district-random-color"
              />
            </div>
          </div>
          <div class="col-sm-3 col-6">
            <div class="form-check form-check-inline">
              <label class="form-check-label mr-2" for="district-custom-color">Custom Color</label>
              <input
                class="form-check-input"
                type="checkbox"
                v-model="mapConfig.district_map.custom_color"
                @change="enableCustomColor('district_map')"
                value="true"
                id="district-custom-color"
              />
            </div>
          </div>
          <div class="col-sm-3 col-6" v-if="mapConfig.district_map.custom_color">
            <div class="form-check form-check-inline">
              <label class="form-check-label mr-2" for="district-custom-color-code">Pick Color</label>
              <input
                class="form-check-input"
                type="color"
                v-model="mapConfig.district_map.custom_color_code"
                id="district-custom-color-code"
              />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-check form-check-inline">
              <label class="form-check-label mr-2" for="district-hover-color">Hover Color</label>
              <input
                class="form-check-input"
                type="color"
                v-model="mapConfig.district_map.hover_color"
                id="district-hover-color"
              />
            </div>
          </div>
        </div>
        <form class="form-inline">
          <div class="form-group">
            <div class="form-check form-check-inline">
              <label class="form-check-label mr-2" for="district-stroke-color">Stroke Color</label>
              <input
                class="form-check-input"
                type="color"
                v-model="mapConfig.district_map.stroke_color"
                id="district-stroke-color"
              />
            </div>

            <label class="mr-2">Stroke Width</label>
            <input
              style="height:30px !important; width: 100px !important"
              class="form-control mr-4"
              type="number"
              v-model="mapConfig.district_map.stroke_width"
              id="district-stroke-width"
            />
            <label class="mr-2">Trigger Mode</label>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                id="districtTriggerClick"
                value="click"
                v-model="mapConfig.district_map.trigger_mode"
              />
              <label class="form-check-label" for="districtTriggerClick">Click</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="inlineRadioOptions"
                v-model="mapConfig.district_map.trigger_mode"
                id="districtTriggerHover"
                value="hover"
              />
              <label class="form-check-label" for="districtTriggerHover">Hover</label>
            </div>
          </div>
        </form>
      </div>
      <div class="col-sm-8 mt-4">
        <DistrictMap
          :set-random-color="mapConfig.district_map.random_color"
          :color="mapConfig.district_map.custom_color_code"
          :hover-color="mapConfig.district_map.hover_color"
          :stroke-color="mapConfig.district_map.stroke_color"
          :stroke-width="mapConfig.district_map.stroke_width"
          :on-map-click="(mapConfig.district_map.trigger_mode === 'click') ? districtMapTriggered : () => {return;}"
          :on-map-hover="(mapConfig.district_map.trigger_mode === 'hover') ? districtMapTriggered : () => {return;}"
        />
      </div>
      <div class="col-sm-4 p-2">
        <h5>Result JSON</h5>
        <pre class="mt-4 json--wrapper">{{ mapConfig.district_map.active_item | pretty }}</pre>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-sm-12 mb-4">
        <h4>2. Zone Map</h4>
      </div>
      <div class="col-sm-12">
        <h5 class="font-weight-bold">Configurations</h5>
      </div>
      <div class="col-sm-12">
        <div class="form-group row">
          <div class="col-sm-3">
            <div class="form-check form-check-inline">
              <label class="form-check-label mr-2" for="zone-random-color">Random Color</label>
              <input
                class="form-check-input"
                type="checkbox"
                v-model="mapConfig.zone_map.random_color"
                @change="toggleRandomColor('zone_map')"
                value="true"
                id="zone-random-color"
              />
            </div>
          </div>
          <div class="col-sm-3 col-6">
            <div class="form-check form-check-inline">
              <label class="form-check-label mr-2" for="zone-custom-color">Custom Color</label>
              <input
                class="form-check-input"
                type="checkbox"
                v-model="mapConfig.zone_map.custom_color"
                @change="enableCustomColor('zone_map')"
                value="true"
                id="zone-custom-color"
              />
            </div>
          </div>
          <div class="col-sm-3 col-6" v-if="mapConfig.zone_map.custom_color">
            <div class="form-check form-check-inline">
              <label class="form-check-label mr-2" for="zone-custom-color-code">Pick Color</label>
              <input
                class="form-check-input"
                type="color"
                v-model="mapConfig.zone_map.custom_color_code"
                id="zone-custom-color-code"
              />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-check form-check-inline">
              <label class="form-check-label mr-2" for="zone-hover-color">Hover Color</label>
              <input
                class="form-check-input"
                type="color"
                v-model="mapConfig.zone_map.hover_color"
                id="zone-hover-color"
              />
            </div>
          </div>
        </div>
        <form class="form-inline">
          <div class="form-group">
            <div class="form-check form-check-inline">
              <label class="form-check-label mr-2" for="zone-stroke-color">Stroke Color</label>
              <input
                class="form-check-input"
                type="color"
                v-model="mapConfig.zone_map.stroke_color"
                id="zone-stroke-color"
              />
            </div>

            <label class="mr-2">Stroke Width</label>
            <input
              style="height:30px !important; width: 100px !important"
              class="form-control mr-4"
              type="number"
              v-model="mapConfig.zone_map.stroke_width"
              id="zone-stroke-width"
            />
            <label class="mr-2">Trigger Mode</label>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="zoneTriggerRadio"
                id="zoneTriggerClick"
                value="click"
                v-model="mapConfig.zone_map.trigger_mode"
              />
              <label class="form-check-label" for="zoneTriggerClick">Click</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="zoneTriggerRadio"
                id="zoneTriggerHover"
                v-model="mapConfig.zone_map.trigger_mode"
                value="hover"
              />
              <label class="form-check-label" for="zoneTriggerHover">Hover</label>
            </div>
          </div>
        </form>
      </div>
      <div class="col-sm-8 mt-4">
        <ZoneMap
          :set-random-color="mapConfig.zone_map.random_color"
          :color="mapConfig.zone_map.custom_color_code"
          :hover-color="mapConfig.zone_map.hover_color"
          :stroke-color="mapConfig.zone_map.stroke_color"
          :stroke-width="mapConfig.zone_map.stroke_width"
          :on-map-click="(mapConfig.zone_map.trigger_mode === 'click') ? zoneMapTriggered : () => {return;}"
          :on-map-hover="(mapConfig.zone_map.trigger_mode === 'hover') ? zoneMapTriggered : () => {return;}"
        />
      </div>
      <div class="col-sm-4 p-2">
        <h5>Result JSON</h5>
        <pre class="mt-4 json--wrapper">{{ mapConfig.zone_map.active_item | pretty }}</pre>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-sm-12 mb-4">
        <h4>3. Province Map</h4>
      </div>
      <div class="col-sm-12">
        <h5 class="font-weight-bold">Configurations</h5>
      </div>
      <div class="col-sm-12">
        <div class="form-group row">
          <div class="col-sm-3">
            <div class="form-check form-check-inline">
              <label class="form-check-label mr-2" for="province-random-color">Random Color</label>
              <input
                class="form-check-input"
                type="checkbox"
                v-model="mapConfig.province_map.random_color"
                @change="toggleRandomColor('province_map')"
                value="true"
                id="province-random-color"
              />
            </div>
          </div>
          <div class="col-sm-3 col-6">
            <div class="form-check form-check-inline">
              <label class="form-check-label mr-2" for="province-custom-color">Custom Color</label>
              <input
                class="form-check-input"
                type="checkbox"
                v-model="mapConfig.province_map.custom_color"
                @change="enableCustomColor('province_map')"
                value="true"
                id="province-custom-color"
              />
            </div>
          </div>
          <div class="col-sm-3 col-6" v-if="mapConfig.province_map.custom_color">
            <div class="form-check form-check-inline">
              <label class="form-check-label mr-2" for="province-custom-color-code">Pick Color</label>
              <input
                class="form-check-input"
                type="color"
                v-model="mapConfig.province_map.custom_color_code"
                id="province-custom-color-code"
              />
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-check form-check-inline">
              <label class="form-check-label mr-2" for="province-hover-color">Hover Color</label>
              <input
                class="form-check-input"
                type="color"
                v-model="mapConfig.province_map.hover_color"
                id="province-hover-color"
              />
            </div>
          </div>
        </div>
        <form class="form-inline">
          <div class="form-group">
            <div class="form-check form-check-inline">
              <label class="form-check-label mr-2" for="province-stroke-color">Stroke Color</label>
              <input
                class="form-check-input"
                type="color"
                v-model="mapConfig.province_map.stroke_color"
                id="province-stroke-color"
              />
            </div>

            <label class="mr-2">Stroke Width</label>
            <input
              style="height:30px !important; width: 100px !important"
              class="form-control mr-4"
              type="number"
              v-model="mapConfig.province_map.stroke_width"
              id="province-stroke-width"
            />
            <label class="mr-2">Trigger Mode</label>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="provinceTriggerRadio"
                id="provinceTriggerClick"
                value="click"
                v-model="mapConfig.province_map.trigger_mode"
              />
              <label class="form-check-label" for="provinceTriggerClick">Click</label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                name="provinceTriggerRadio"
                id="provinceTriggerHover"
                v-model="mapConfig.province_map.trigger_mode"
                value="hover"
              />
              <label class="form-check-label" for="provinceTriggerHover">Hover</label>
            </div>
          </div>
        </form>
      </div>
      <div class="col-sm-8 mt-4">
        <ProvinceMap
          :set-random-color="mapConfig.province_map.random_color"
          :color="mapConfig.province_map.custom_color_code"
          :hover-color="mapConfig.province_map.hover_color"
          :stroke-color="mapConfig.province_map.stroke_color"
          :stroke-width="mapConfig.province_map.stroke_width"
          :on-map-click="(mapConfig.province_map.trigger_mode === 'click') ? provinceMapTriggered : () => {return;}"
          :on-map-hover="(mapConfig.province_map.trigger_mode === 'hover') ? provinceMapTriggered : () => {return;}"
        />
      </div>
      <div class="col-sm-4 p-2">
        <h5>Result JSON</h5>
        <pre class="mt-4 json--wrapper">{{ mapConfig.province_map.active_item | pretty }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import { DistrictMap, ZoneMap, ProvinceMap } from "vue-great-nepal";
// require styles
export default {
  data() {
    return {
      mapConfig: {
        district_map: {
          active_item: "{}",
          stroke_width: 1,
          random_color: false,
          custom_color: false,
          custom_color_code: null,
          hover_color: "#b0b0b0",
          stroke_color: "#000000",
          trigger_mode: "hover"
        },
        zone_map: {
          active_item: "{}",
          stroke_width: 1,
          random_color: false,
          custom_color: false,
          custom_color_code: null,
          hover_color: "#b0b0b0",
          stroke_color: "#000000",
          trigger_mode: "hover"
        },
        province_map: {
          active_item: "{}",
          stroke_width: 1,
          random_color: false,
          custom_color: false,
          custom_color_code: null,
          hover_color: "#b0b0b0",
          stroke_color: "#000000",
          trigger_mode: "hover"
        }
      }
    };
  },
  filters: {
    pretty: function(value) {
      return JSON.stringify(JSON.parse(value), null, 2);
    }
  },
  mounted() {},
  components: {
    DistrictMap,
    ZoneMap,
    ProvinceMap
  },
  methods: {
    enableCustomColor(map_type) {
      if (this.mapConfig[map_type].custom_color) {
        this.mapConfig[map_type].custom_color_code = "#c5ffca";
      } else {
        this.mapConfig[map_type].custom_color_code = null;
      }
      this.mapConfig[map_type].random_color = false;
    },

    toggleRandomColor(map_type) {
      this.mapConfig[map_type].custom_color = false;
      this.mapConfig[map_type].custom_color_code = null;
    },

    districtMapTriggered(data) {
      this.mapConfig.district_map.active_item = JSON.stringify(data);
    },

    zoneMapTriggered(data) {
      this.mapConfig.zone_map.active_item = JSON.stringify(data);
    },

    provinceMapTriggered(data) {
      this.mapConfig.province_map.active_item = JSON.stringify(data);
    }
  }
};
</script>

<style scoped>
.json--wrapper {
  background: rgb(37, 37, 37);
  padding: 20px;
  min-height: 280px;
  font-size: 14px;
  color: rgb(211, 211, 211);
}
</style>